import React, { Fragment, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Card from '../../components/Card'; 

function CityPage() {
  const [city, setCity] = useState(null);
  const [relatedObjects, setRelatedObjects] = useState([]); 
  const [loadingRelatedObjects, setLoadingRelatedObjects] = useState(true); 
  const { plcid } = useParams(); 
  const uniqueObjectIds = new Set(); 

  const fetchCity = async () => {
    try {
      const response = await fetch(`/api/place/city/${plcid}`);
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }
      const jsonData = await response.json();
      setCity(jsonData[0]); 


      const objectIds = Array.isArray(jsonData[0].obj_id) ? jsonData[0].obj_id : [jsonData[0].obj_id];

      for (const id of objectIds) {
        console.log(`Fetching related object with ID: ${id}`); 
        await fetchRelatedObject(id); 
      }
      
    } catch (err) {
      console.error(err.message);
    }
  };


  const fetchRelatedObject = async (id) => {
    try {
      const response = await fetch(`/api/item/${id}`);
      const jsonData = await response.json();


      const newObjects = Array.isArray(jsonData) ? jsonData : [jsonData];


      newObjects.forEach(newObj => {
        if (!uniqueObjectIds.has(newObj.obj_id)) {
          uniqueObjectIds.add(newObj.obj_id); 
          setRelatedObjects(prevObjects => [...prevObjects, newObj]); 
        }
      });

      setLoadingRelatedObjects(false);

      console.log("Updated relatedObjects:", relatedObjects);
    } catch (err) {
      console.error("Error fetching related objects:", err);
      setLoadingRelatedObjects(false); 
    }
  };

  useEffect(() => {
    fetchCity();
  }, [plcid]);

  if (!city) {
    return <p>Loading...</p>; 
  }

  return (
<Fragment>
  <div className="detailpage">
    <h1>City: {city.city_name}</h1>
    <div className="detailpage_desc">
      
    <div className="detailpg_data_row">      
    <h4 className="detailpg_title">Parent Country:</h4>

        <div className="place-list">
          <div className="place-item">
            <Link to={`../place/country/${city.cont_id}`}>
              <span className="data-value"><h4>{city.country}</h4></span>
            </Link>
          </div>
        </div>
      </div>

    <div className="place-wrapper">
      <div className="detailpg_data_row">               
        {city.towns && city.towns[0] !== null ? (
        <>
        <h4 className="detailpg_title">Child Town/District:</h4>
          <div className="place-list">
            {city.towns.map((town, index) => (
            <div key={index} className="place-item">
              <Link to={`../place/town/${city.town_ids[index]}`}>
                <span className="data-value"><h4>{town}</h4></span>
              </Link>
              {index < city.towns.length - 1 && <span className="separator">,</span>} {}
            </div>                         
           ))}
             </div>    
            </>
            ) : (
        <div className="na">No Data</div>
        )}
        </div>
      </div>
    </div>


    <h4 id="rel_title">Related Objects</h4>
      <div className="related-objects">
      <div className="container">
      <div className="wrapper">
      <div className="csrow">
              {relatedObjects.map(object => {
                const media = object.media ? 'thumb_' + object.media.split(',')[0] : '';  
                
                return (
                  <Card
                    key={object.obj_id}
                    id={object.obj_id}
                    ref_id={object.ref_id}
                    title={object.title}
                    media={media}  
                    media_type={object.med_name}
                    project={object.prj_name}
                    record_date={object.record_date ? new Date(object.record_date).toLocaleDateString() : 'No date available'}
                  />
                );
              })}
            </div>            
        </div>
        </div>
        </div>
        </div>
    </Fragment>
  );
}

export default CityPage;
